module.exports = __webpack_public_path__ + "images/emoji/bus.f3a0422c716325ae6fd9.png";